export default {
  TimeFormField__FORMAT: "h:mma",
};
